export const selectLabelerId = (state) => state.members.labelerId;
export const selectReviewerId = (state) => state.members.reviewerId;
export const selectLabelers = (state) => state.members.labelers;
export const selectReviewers = (state) => state.members.reviewers;
